import axios from "axios";

export default async function commitNewObject(projectName, formName, data) {
    await axios.post(`/project/${projectName}/${formName}/add-document/commit`, data)
}